import { createSlice } from '@reduxjs/toolkit';
import { m } from '../../utils/date';


const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 0,
    }
};

const contractSlice = createSlice({
    name: 'contract',
    initialState,
    reducers: {
        funGetContracts(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map((contract) =>{
                //const {contractDt, dueDt, releaseDt, regDt, updDt, } = contract;
                return{
                    ...contract,
                    contractDt: m.date({ value: contract.contractDt }),
                    dueDt: m.date({ value: contract.dueDt }),
                    releaseDt: m.date({ value: contract.releaseDt }),
                    regDt: m.dateTime({ value: contract.regDt }),
                    updDt: m.dateTime({ value: contract.updDt }),
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const contractActions = contractSlice.actions;
export default contractSlice.reducer;